import { EnumConversationState } from '../enums/conversation-state.enum';

export type ConversationChannel = 'web' | 'whatsapp';

/* eslint-disable @typescript-eslint/naming-convention */
export interface IConversationViewRaw {
  id: string;
  title: string | null;
  is_pinned: boolean;
  pinned_at: string | null;
  created_at: string;
  last_message_at: string | null;
  org_id?: number;
  user_id?: number;
  channel?: ConversationChannel;
  channel_metadata?: Record<string, unknown>;
  summary?: string | null;
  agent_route?: string | null;
  state?: EnumConversationState;
  state_revision?: number;
  title_revision?: number;
  archived_at?: string | null;
  message_count?: number;
  updated_at?: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface IConversationView {
  id: string;
  title: string | null;
  isPinned: boolean;
  pinnedAt: string | null;
  createdAt: string;
  lastMessageAt: string | null;
  orgId?: number;
  userId?: number;
  channel?: ConversationChannel;
  channelMetadata?: Record<string, unknown>;
  summary?: string | null;
  agentRoute?: string | null;
  state?: EnumConversationState;
  stateRevision?: number;
  titleRevision?: number;
  archivedAt?: string | null;
  messageCount?: number;
  updatedAt?: string;
}

export const toConversationView = (raw: IConversationViewRaw): IConversationView => ({
  id: raw.id,
  title: raw.title,
  isPinned: raw.is_pinned,
  pinnedAt: raw.pinned_at,
  createdAt: raw.created_at,
  lastMessageAt: raw.last_message_at,
  orgId: raw.org_id,
  userId: raw.user_id,
  channel: raw.channel,
  channelMetadata: raw.channel_metadata,
  summary: raw.summary,
  agentRoute: raw.agent_route,
  state: raw.state,
  stateRevision: raw.state_revision,
  titleRevision: raw.title_revision,
  archivedAt: raw.archived_at,
  messageCount: raw.message_count,
  updatedAt: raw.updated_at
});
